export default function Contact() {
    return (
        <div>
            <section id="contact">
                <h2>Reach out!</h2>
                <iframe
                    src="https://docs.google.com/forms/d/e/1FAIpQLSfXWpKPi2JKIxP8jRllx9GhAVDg4T2xg2HZdHz5hQPD1b4bOg/viewform?usp=dialog"
                    width="600"
                    height="800"
                >
                    Loading…
                </iframe>
            </section>
        </div>
    )
}